export default __webpack_public_path__ + "static/media/ProfileFrame.75f96a22.svg";